/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HealthCareServiceLocationSearchResultModel } from '../../models/health-care-service-location-search-result-model';

export interface AdminFhirIdLocationGet$Params {
  fhirId: string;
}

export function adminFhirIdLocationGet(http: HttpClient, rootUrl: string, params: AdminFhirIdLocationGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<Array<HealthCareServiceLocationSearchResultModel>>> {
  const rb = new RequestBuilder(rootUrl, adminFhirIdLocationGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<Array<HealthCareServiceLocationSearchResultModel>>;
    })
  );
}

adminFhirIdLocationGet.PATH = '/Admin/{fhirId}/Location';
